var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAcademicHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.81818C12 6.00445 12.3233 5.22405 12.8987 4.64865C13.474 4.07325 14.2544 3.75 15.0682 3.75H21.2045C21.408 3.75 21.6031 3.83081 21.7469 3.97466C21.8908 4.11851 21.9716 4.31361 21.9716 4.51705V16.7898C21.9716 16.9932 21.8908 17.1883 21.7469 17.3322C21.6031 17.476 21.408 17.5568 21.2045 17.5568H15.0682C14.2544 17.5568 13.474 17.8801 12.8987 18.4555C12.3233 19.0309 12 19.8113 12 20.625",
    fill: "#90CAF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.81818C12 6.00445 12.3233 5.22405 12.8987 4.64865C13.474 4.07325 14.2544 3.75 15.0682 3.75H21.2045C21.408 3.75 21.6031 3.83081 21.7469 3.97466C21.8908 4.11851 21.9716 4.31361 21.9716 4.51705V16.7898C21.9716 16.9932 21.8908 17.1883 21.7469 17.3322C21.6031 17.476 21.408 17.5568 21.2045 17.5568H15.0682C14.2544 17.5568 13.474 17.8801 12.8987 18.4555C12.3233 19.0309 12 19.8113 12 20.625",
    stroke: "#90CAF4",
    strokeWidth: 1.84358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 16.7898C2.03125 16.9932 2.11206 17.1883 2.25591 17.3322C2.39976 17.476 2.59486 17.5568 2.7983 17.5568H8.93466C9.74839 17.5568 10.5288 17.8801 11.1042 18.4555C11.6796 19.0309 12.0028 19.8113 12.0028 20.625V6.81818C12.0028 6.00445 11.6796 5.22405 11.1042 4.64865C10.5288 4.07325 9.74839 3.75 8.93466 3.75H2.7983C2.59486 3.75 2.39976 3.83081 2.25591 3.97466C2.11206 4.11851 2.03125 4.31361 2.03125 4.51705V16.7898Z",
    fill: "#90CAF4",
    stroke: "#90CAF4",
    strokeWidth: 1.84358,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26953 8.83594H8.95668",
    stroke: "#2B6CB0",
    strokeWidth: 1.84358,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26953 11.9082H7.72763",
    stroke: "#2B6CB0",
    strokeWidth: 1.84358,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.125L12 21",
    stroke: "#2B6CB0",
    strokeWidth: 1.22905,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicHistory);
export default __webpack_public_path__ + "static/media/academicHistory.d3ef5f32f20e967cecb76f8e0681d6fd.svg";
export { ForwardRef as ReactComponent };